<script lang="ts">
	// Stores
	import { sidePanelStateCombined } from 'src/stores/ui/sidepanel-public';
	import { devices } from 'src/stores/lists/devices';

	// Design System Components
	import { SidepanelContent } from '@Shelly/shelly-design-system';

	// Components
	import NotificationsPanel from 'src/components/NotificationsPanel.svelte';

	// Types
	import type { Device } from 'src/types/Device';

	// Get device data from sidepanel state (fallback when not passed by parent)
	let id = $sidePanelStateCombined?.id;
	export let device: Device = $devices[id];
</script>

<SidepanelContent>
	{#if device}
		<NotificationsPanel {device} />
	{:else}
		<div class="loading-state">
			<div class="flex-full-height"></div>
		</div>
	{/if}
</SidepanelContent>
